export const getLabelMap = (data = [], defaultLabelMap = {}) => data.reduce(
  (result, { name, id }) => ({ ...result, [id]: name }),
  defaultLabelMap,
);
